import { FormattedMessage } from "react-intl"
import { P } from "shared/styles/textStyles"
import styled from "styled-components"

import { PlayerError, PlayerErrorCode } from "../types"

const getErrorMessage = (error: PlayerError): JSX.Element => {
  if (
    "code" in error &&
    error?.code === PlayerErrorCode.WEBRTC_NOT_SUPPORTED
  ) {
    return (
      <FormattedMessage
        id="video.webrtcError"
        defaultMessage="WebRTC video isn't supported by this browser. Please update or use Chrome or Firefox."
      />
    )
  }
  if (
    "code" in error &&
    error?.code === PlayerErrorCode.REACHED_VIEWING_CAPACITY
  ) {
    return (
      <FormattedMessage
        id="video.capacityError"
        defaultMessage="We're sorry, This broadcast has reached capacity for live viewing. Please try again shortly."
      />
    )
  }
  if (
    "code" in error &&
    error?.code === PlayerErrorCode.RECORDING_NOT_FOUND
  ) {
    return (
      <FormattedMessage
        id="video.recordingNotFound"
        defaultMessage="We're sorry, this broadcast wasn't found. Please make sure the url is correct."
      />
    )
  }
  return (
    <FormattedMessage
      id="video.defaultError"
      defaultMessage="We're sorry, something went wrong watching this broadcast. Try refreshing the page."
    />
  )
}

const PlayerErrorContainer = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: ${(props) => props.theme.zIndex.splashPage};

  background-color: ${(props) => props.theme.colors.black70};
  font-family: ${(props) => props.theme.font.primary};

  display: flex;
  align-items: center;
  justify-content: center;

  ${P} {
    width: 70%;
    font-size: 1.57rem;
    font-weight: 300;
    line-height: 1.5;
    text-align: center;
    color: ${(props) => props.theme.colors.white};
  }
`

type PlayerErrorMessageProps = {
  error: PlayerError
}

export const PlayerErrorMessage = ({ error }: PlayerErrorMessageProps) => {
  const errorMessage = getErrorMessage(error)
  return (
    <PlayerErrorContainer>
      <P>{errorMessage}</P>
    </PlayerErrorContainer>
  )
}
